import { apiSlice } from "../../apiSlice";
export const opesnfacApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicOpesnfac: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Opesnfac`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateExcelOpesnfac: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Opesnfac/generateExcel`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getDataGroupsOpesnfac: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Opesnfac/getDataGroups`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
  }),
});

export const { useGenerateExcelOpesnfacMutation, useGetDataGraphicOpesnfacMutation, useGetDataGroupsOpesnfacMutation } =
  opesnfacApiSlice;
